import React from "react";

const currentYear = new Date().getFullYear();

export const Team = (props) => {
  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Notre équipes</h2>
          <p>
            Derrière chaque réussite, il y a une équipe d’exception.
            Voici les cerveaux et les cœurs qui guident France Papiers Solutions.
          </p>
        </div>
        <div id="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-3 col-sm-6 team">
                  <div className="thumbnail">
                    {" "}
                    <img src={d.img} alt="..." className="team-img" />
                    <div className="caption">
                      <h4>{d.name}</h4>
                      <p>{d.job}</p>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; {currentYear} France Papiers Solutions. Designed by{" "}
            <a href="http://www.facebook.com/waviloid.studio" rel="nofollow">
              Waviloid Studio
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
